define('AwaLabs.HomeFeaturedProducts', [
    'HomeFeaturedProducts.View',
    'HomeFeaturedProducts.Home.View'
], function AwaLabsHomeFeaturedProducts(
    HomeFeaturedProductsView
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            var environment = container.getComponent('Environment');
            var config = environment.getConfig('HomeFeaturedProducts');
            if (layout) {
                layout.addChildView('HomeFeaturedProducts', function homeFeaturedProductsView() {
                    return new HomeFeaturedProductsView({
                        application: container,
                        config: config
                    });
                });
            }
        }
    };
});
